// removed by extract-text-webpack-plugin
module.exports = {"benefitsContainer":"benefitsContainer__2eJJ0","headerText":"headerText__1eZuo","text":"text__2Rjxb","subHeaderText":"subHeaderText__22Brr","lenderIcon":"lenderIcon__1rWow","benefitsDetails":"benefitsDetails__3wY67"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEmiDetails/benefitsSection/style.css
// module id = DRve
// module chunks = 323 328 331